/* ============================================================
   Hond & Buiten — Cross-sell quick-add ("Maak je uitrusting compleet")
   - Variantkeuze in de kaart (geen willekeurige default)
   - CTA disabled tot geldige variant -> "Kies eerst <optie>"
   - Voegt direct toe aan dezelfde Shopify-cart (AJAX, geen reload)
   Vanilla JS. Verwijdert de Follow LIGHT niet uit de cart.
   ============================================================ */
(function () {
  'use strict';

  function friendly(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('breedte') > -1) return 'breedte';
    if (n.indexOf('kleur') > -1) return 'kleur';
    if (n.indexOf('maat') > -1) return 'maat';
    return name.toLowerCase();
  }

  async function updateCartCount() {
    try {
      var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      document.querySelectorAll('.cart-bubble, [ref="cartBubbleCount"], .cart-count, [data-cart-count], .header-actions__cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = false;
        el.removeAttribute('hidden');
      });
      // Laat het thema (indien het luistert) de cart verversen.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
    } catch (e) {}
  }

  function initCard(card) {
    if (card.dataset.hbCsInit === '1') return;
    var variantsEl = card.querySelector('.hb-cs-variants');
    var cta = card.querySelector('.hb-cs-add');
    if (!variantsEl || !cta) return; // geen varianten -> laat de kaart met CTA-link staan
    card.dataset.hbCsInit = '1';

    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    var groups = [].slice.call(card.querySelectorAll('.hb-cs-optgroup'));
    var optNames = groups.map(function (g) { return g.dataset.optName; });
    var selected = {}; // index -> value

    function firstUnselectedName() {
      for (var i = 0; i < groups.length; i++) {
        if (selected[i] == null) return optNames[i];
      }
      return null;
    }
    function matchVariant() {
      return variants.find(function (v) {
        return groups.every(function (g, i) { return v.options[i] === selected[i]; });
      });
    }
    function update() {
      var missing = firstUnselectedName();
      if (missing != null) {
        cta.disabled = true;
        cta.textContent = 'Kies eerst ' + friendly(missing);
        delete cta.dataset.variantId;
        return;
      }
      var v = matchVariant();
      if (!v) { cta.disabled = true; cta.textContent = 'Niet beschikbaar'; return; }
      if (v.available === false) { cta.disabled = true; cta.textContent = 'Uitverkocht'; return; }
      cta.disabled = false;
      cta.textContent = 'Voeg toe aan bestelling';
      cta.dataset.variantId = v.id;
    }

    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.hb-cs-optbtn');
        if (!b || b.disabled) return;
        e.preventDefault();
        selected[gi] = b.dataset.val;
        [].slice.call(g.querySelectorAll('.hb-cs-optbtn')).forEach(function (x) {
          x.classList.toggle('is-selected', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        update();
      });
    });

    cta.addEventListener('click', async function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      var id = cta.dataset.variantId;
      if (!id) return;
      var orig = 'Voeg toe aan bestelling';
      cta.disabled = true;
      cta.textContent = 'Bezig…';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed ' + res.status);
        cta.textContent = 'Toegevoegd ✓';
        cta.classList.add('is-added');
        await updateCartCount();
        setTimeout(function () {
          cta.classList.remove('is-added');
          cta.disabled = false;
          cta.textContent = orig;
        }, 2600);
      } catch (err) {
        cta.textContent = 'Mislukt — opnieuw';
        setTimeout(function () { cta.disabled = false; cta.textContent = orig; }, 2600);
      }
    });

    update();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('.hb-complete-kit .hb-kit-card')).forEach(initCard);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
